
import { batch } from 'react-redux' ;
 
import { store, allFormules, defineListeCompagnies,
         defineListeCompagniesAffichees , modifyDisplaymodal} from "../state/redux";
import { queryClient } from '../state/queryClient';

import { axios_gestion_getallfomulesempty } from '../axios/axios_gestion';


export const isclassblur =() =>{
        const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
        return  user?.showtarifs!==1?'blur':'' };


export const radintarifs =async () =>{
    let reqformules = await axios_gestion_getallfomulesempty() ;
       
    batch( () => {  store.dispatch(allFormules(reqformules.data.map(f=>{return {...f,'prix':(Math.floor(Math.random() * 10000))/100 }}))); 
                    store.dispatch(defineListeCompagnies([...new Set(reqformules.data.map(x=>x.compagnie))].sort()));
                    store.dispatch(defineListeCompagniesAffichees([...new Set(reqformules.data.map(x=>x.compagnie))].sort()));
        });
}

export const radinpopup = ()=>{ store.dispatch(modifyDisplaymodal('mod_popupradin')) ;}
